import { styled } from "styled-components";
import { mobile } from "../../../../storybook/utils/breakpoints";
import { patientFacingTheme } from "storybook/themes/patient-facing";

const { colors } = patientFacingTheme;

export const Container = styled.div`
  padding: 10px;

  && {
    h1 {
      font-size: 28px;
      font-weight: 700px;
      padding-bottom: 10px;
    }
  }

  form > p {
    margin-top: 20px;
  }

  @media (min-width: ${mobile}px) {
    padding: 20px;
  }
`;

export const RadioRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const AccordorionsSection = styled.section`
  margin-top: 20px;
`;

export const AccordionContainer = styled.div`
  margin-bottom: 15px;

  summary {
    padding-left: 15px;
  }

  && {
    summary {
      label {
        font-weight: 700;
      }
    }

    h2 {
      display: none;
    }

    @media (min-width: ${mobile}px) {
      h2 {
        display: block;
      }
    }
  }
`;

export const AccordionDetails = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  && {
    h2 {
      color: #8d8a8a;
      font-weight: 500;
      user-select: none;
    }
  }
`;

export const CalendarContainer = styled.div`
  margin-top: 45px;
  padding-bottom: 20px;

  && {
    h2 {
      font-weight: 700;
      font-size: 18px;
      margin: 20px 0 20px 0;
    }
  }
`;

export const ButtonsContainer = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  flex-direction: column-reverse;

  && {
    a {
      text-transform: capitalize;
    }

    a,
    button {
      width: 100%;
    }
  }

  && {
    button {
      font-size: 18px;
      height: 42px;
      text-transform: uppercase;
      background-color: ${colors.camelot};
    }
  }

  @media (min-width: ${mobile}px) {
    flex-direction: row;

    && {
      a,
      button {
        width: 300px;
      }
    }
  }
`;

export const AccordionContents = styled.div`
  padding: 16px;
  display: flex;
  justify-content: center;
`;

export const ContentWrapper = styled.div`
  display: inline-block;
  max-width: 600px;
  width: auto;

  && {
    h3 {
      font-weight: 700;
      margin: 15px 0 10px 0;
      padding-bottom: 10px;
    }

    h3 + p {
      font-size: 16px;
      font-weight: 500;
      padding-bottom: 5px;
      margin: 0;
    }

    h4 {
      font-size: 16px;
      font-weight: 700;
      margin: 15px 0 15px 0;
    }

    ul {
      margin: 5px 0 10px 0;
    }

    #page2 > main {
      height: auto !important;
    }

    .columns-container.separator {
      border: none;
    }

    img {
      max-width: 100%;
    }
  }
`;

export const BannerContainer = styled.div`
  margin: 10px 0 20px 0;

  @media (min-width: ${mobile}px) {
    margin-bottom: 10px;
  }
`;

export const RemainderText = styled.span`
  font-weight: 700;
  color: ${colors.camelot};
`;
